import { FC } from 'react'
import styles from './WallOfLove.module.scss'
import { Img } from 'components/basic/Img'
import { Button } from 'components/WebEv/Buttons'
import { CTAItem } from './wallOfLoveIterfaces'
import cx from 'classnames'
import { Type } from 'components/Type'

export const CTACard: FC<Omit<CTAItem, 'categories'> & { id: string; saleName: string }> = (props) => {
	return (
		<div
			className={cx(styles.container, 'wall-of-love-cta')}
			id={props.id}
			key={`cta-${props.id}`}
		>
			<Img
				src={'https://eightsleep.imgix.net/cta_photo.jpg?v=1692127314'}
				dprHeight={300}
				alt={'A render of the Pod'}
			/>

			<div className={styles.cta_card_content}>
				<div className={styles.cta_badge_container}>
					<p className={styles.cta_badge}>{props.saleName}</p>
				</div>

				<Type.Headchapter className={styles.cta_headline}>{props.title}</Type.Headchapter>
				<Type.Body2 className={styles.cta_subheadline}>{props.subtitle}</Type.Body2>
				<Button.Primary
					id={`reviews-page-cta-card-${props.image}`}
					href={props.ctaLink}
					className={styles.cta_card_cta}
				>
					{props.cta}
				</Button.Primary>
			</div>
		</div>
	)
}
